<div #shortcuts id="fuse-shortcuts">
  @if (!mobileShortcutsPanelActive) {
    <div class="shortcuts-mobile-toggle fx-hide fxl-row fxla-start-center fx-show-flex_lt-md">
      <button (click)="showMobileShortcutsPanel()" mat-icon-button><mat-icon class="accent-fg">star</mat-icon></button>
    </div>
  }
  <div class="shortcuts fx-hide fxl-row fx-show-flex_gt-sm">
    <div class="fxf-0-1-auto-r fxl-row fxla-space-between-center">
      <div class="fxl-row fxla-start-center">
        @for (shortcutItem of displayableShortcutItems; track shortcutItem.url) {
          <div class="w-40 h-40 p-4 fxl-row fxla-center-center">
            <a [routerLink]="shortcutItem.url" mat-icon-button matTooltip="{{ shortcutItem.translate | translate }}">
              @if (shortcutItem.icon; as icon) {
                @if (icon.startsWith('svg')) {
                  <mat-icon class="secondary-text" svgIcon="{{ icon }}"></mat-icon>
                } @else {
                  <mat-icon class="secondary-text">{{ icon }}</mat-icon>
                }
              } @else {
                <span class="h2 secondary-text text-bold"> {{ (shortcutItem.translate | translate).substr(0, 1).toUpperCase() }} </span>
              }
            </a>
          </div>
        }

        <button
          (menuOpened)="onMenuOpen()"
          [matMenuTriggerFor]="addMenu"
          mat-icon-button
          matTooltip="{{ 'SHORTCUT.CLICK_TO_ADD' | translate }}"
        >
          <mat-icon class="accent-fg">star</mat-icon>
        </button>
      </div>

      <div class="shortcuts-mobile-close fx-hide fxl-row fxla-start-center fx-show-flex_lt-md">
        <button (click)="hideMobileShortcutsPanel()" mat-icon-button><mat-icon>close</mat-icon></button>
      </div>
    </div>

    <mat-menu #addMenu="matMenu" class="w-240">
      <mat-form-field (click)="$event.stopPropagation()" class="px-16 w-100-p">
        <mat-label>{{ 'SHORTCUT.SEARCH_FOR_A_PAGE' | translate }}</mat-label>
        <input #searchInput (input)="search($event)" autocomplete="off" matInput />
      </mat-form-field>

      <mat-divider></mat-divider>

      @if (!searching) {
        <mat-nav-list style="max-height: 312px; overflow: auto">
          @for (shortcutItem of displayableShortcutItems; track shortcutItem.url) {
            <mat-list-item (click)="toggleShortcut($event, shortcutItem)">
              <div class="w-100-p fxl-row fxla-start-center">
                @if (shortcutItem.icon; as icon) {
                  @if (icon.startsWith('svg')) {
                    <mat-icon class="mr-8 secondary-text" mat-list-icon svgIcon="{{ icon }}"></mat-icon>
                  } @else {
                    <mat-icon class="mr-8 secondary-text" mat-list-icon>{{ icon }}</mat-icon>
                  }
                } @else {
                  <span class="h2 w-32 h-32 p-4 mr-8 secondary-text text-bold fxl-row fxla-center-center">
                    {{ (shortcutItem.translate | translate).substr(0, 1).toUpperCase() }}
                  </span>
                }
                <p class="fxf-auto-fill-r" matLine>{{ shortcutItem.translate | translate }}</p>
                <mat-icon class="ml-8 accent-fg">star</mat-icon>
              </div>
            </mat-list-item>
          }
          @if (displayableShortcutItems.length === 0) {
            <mat-list-item>
              <p>
                <small>{{ 'SHORTCUT.NO_SHORTCUTS_YET' | translate }}</small>
              </p>
            </mat-list-item>
          }
        </mat-nav-list>
      }
      @if (searching) {
        <mat-nav-list style="max-height: 312px; overflow: auto">
          @for (navigationItem of filteredNavigationItems; track navigationItem.url) {
            <mat-list-item (click)="toggleShortcut($event, navigationItem)">
              <div class="w-100-p fxl-row fxla-start-center">
                @if (navigationItem.icon; as icon) {
                  @if (icon.startsWith('svg')) {
                    <mat-icon class="mr-8 secondary-text" mat-list-icon svgIcon="{{ icon }}"></mat-icon>
                  } @else {
                    <mat-icon class="mr-8 secondary-text" mat-list-icon>{{ icon }}</mat-icon>
                  }
                } @else {
                  <span class="h2 w-32 h-32 p-4 mr-8 secondary-text text-bold fxl-row fxla-center-center">
                    {{ (navigationItem.translate | translate).substr(0, 1).toUpperCase() }}
                  </span>
                }
                <p class="fxf-auto-fill-r" matLine>{{ navigationItem.translate | translate }}</p>
                @if (isInShortcuts(navigationItem)) {
                  <mat-icon class="ml-8 accent-fg">star</mat-icon>
                }
              </div>
            </mat-list-item>
          }
        </mat-nav-list>
      }
    </mat-menu>
  </div>
</div>
